import {CHARGING_DATE} from 'constants/enum/chargingDate'
import ZodConfig from 'constants/zodConfig'
import {z} from 'zod'

const structure = {
    name: 'structure',
    type: 'autocomplete',
    label: 'structure',
    rules: {required: true},
    // defaultValueFieldName: 'structure._id',
    sm: 6,
    xs: 12,
}

const name = {
    name: 'name',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const email = {
    name: 'email',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const phone = {
    name: 'phone',
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const chargingDate = {
    name: 'charging_date',
    type: 'select',
    options: CHARGING_DATE,
    withTranslation: true,
    rules: {required: true},
    sm: 6,
    xs: 12,
}
const taoz = {
    name: 'taoz',
    type: 'checkbox',
    sm: 6,
    xs: 12,
}
const lastInvoiceDate = {
    name: 'last_invoice_date',
    type: 'datepicker',
    sm: 6,
    xs: 12,
}
export const createConsumerField = {
    createConsumer: {
        title: 'createConsumer',
        items: {structure, name, email, phone},
    },
    payment: {
        title: 'payment',
        items: {taoz, chargingDate, lastInvoiceDate},
    },
}

export const createConsumerFieldValidation = z.object({
    structure: ZodConfig.stringDocument(),
    name: ZodConfig.string(),
    email: ZodConfig.string(),
    phone: ZodConfig.string(),
    charging_date: ZodConfig.enum(CHARGING_DATE),
    taoz: ZodConfig.boolean().optional(),
    last_invoice_date: ZodConfig.date().optional().nullable(),
})
